<template>
    <router-view v-if="this.$route.name == 'Sports'"></router-view>
    <router-view :key="$route.fullPath" v-else></router-view>
</template>
<script>
export default {
    name: "SportsModule"
}
</script>